'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderHistory = function (_React$Component) {
	_inherits(OrderHistory, _React$Component);

	function OrderHistory(props) {
		_classCallCheck(this, OrderHistory);

		var _this = _possibleConstructorReturn(this, (OrderHistory.__proto__ || Object.getPrototypeOf(OrderHistory)).call(this, props));

		_this.data = window.ORDER_HISTORY;
		_this.pages = Math.ceil(_this.data.seasons.length / 5);

		_this.state = {
			page: _this.pages,
			seasonTotals: {}
		};
		return _this;
	}

	_createClass(OrderHistory, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (!this.data.data) return;

			var seasonTotals = {};

			this.data.data.forEach(function (store) {
				var seasons = Object.keys(store.seasons);
				seasons.forEach(function (season) {
					if (typeof seasonTotals[season] === 'undefined') {
						seasonTotals[season] = 0;
					}
					seasonTotals[season] += parseFloat(store.seasons[season].value);
				});
			});

			this.setState({
				seasonTotals: seasonTotals
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			if (!this.data.data) return _react2.default.createElement(
				'div',
				{ className: 'order-history' },
				_react2.default.createElement(
					'div',
					{ className: 'no-data' },
					'Nothing to show!'
				)
			);

			var _data = this.data,
			    data = _data.data,
			    seasons = _data.seasons,
			    min = _data.min,
			    max = _data.max;
			var _state = this.state,
			    page = _state.page,
			    seasonTotals = _state.seasonTotals;


			var colStyle = {
				width: Math.min(20, 100 / seasons.length) + '%'
			};

			var sliderStyle = {
				width: Math.max(100, seasons.length / 5 * 100) + '%',
				left: this.sliderPosByPage(page) + '%'
			};

			return _react2.default.createElement(
				'div',
				{ className: 'order-history' },
				_react2.default.createElement(
					'div',
					{ className: 'title' },
					'Order History'
				),
				_react2.default.createElement(
					'div',
					{ className: 'oh-table' },
					_react2.default.createElement(
						'div',
						{ className: 'oh-names' },
						_react2.default.createElement(
							'div',
							{ className: 'oh-row' },
							_react2.default.createElement(
								'div',
								{ className: 'oh-td' },
								_react2.default.createElement(
									'span',
									{ className: (0, _classnames2.default)("prev", { active: page > 1 }), onClick: this.handlePreviousPage.bind(this) },
									'<'
								),
								_react2.default.createElement(
									'span',
									{ className: (0, _classnames2.default)("next", { active: page < this.pages }), onClick: this.handleNextPage.bind(this) },
									'>'
								)
							)
						),
						data.map(function (order, i) {
							return _react2.default.createElement(
								'div',
								{ className: 'oh-row', key: i },
								_react2.default.createElement(
									'div',
									{ className: 'oh-td' },
									_react2.default.createElement(
										'a',
										{ href: "/directory/brands/" + order.slug },
										order.name
									)
								)
							);
						}),
						_react2.default.createElement(
							'div',
							{ className: 'oh-row footer-start oh-foot' },
							_react2.default.createElement(
								'div',
								{ className: 'oh-td' },
								_react2.default.createElement(
									'span',
									{ className: (0, _classnames2.default)("prev", { active: page > 1 }), onClick: this.handlePreviousPage.bind(this) },
									'<'
								),
								_react2.default.createElement(
									'span',
									{ className: (0, _classnames2.default)("next", { active: page < this.pages }), onClick: this.handleNextPage.bind(this) },
									'>'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'oh-row oh-foot' },
							_react2.default.createElement(
								'div',
								{ className: 'oh-td' },
								'Total'
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'oh-data' },
						_react2.default.createElement(
							'div',
							{ className: 'oh-data-slider', style: sliderStyle },
							_react2.default.createElement(
								'div',
								{ className: 'oh-row' },
								seasons.map(function (season, i) {
									return _react2.default.createElement(
										'div',
										{ className: 'oh-td', key: i },
										season
									);
								})
							),
							data.map(function (order, i) {
								return _react2.default.createElement(
									'div',
									{ className: 'oh-row', key: i },
									seasons.map(function (season, j) {

										var currencyValue = order.seasons[season] ? new Intl.NumberFormat('en-gb', { style: 'currency', currency: DISPLAY_CURRENCY }).format(order.seasons[season].value || 0) : '';

										return _react2.default.createElement(
											'div',
											{
												className: 'oh-td',
												key: j,
												style: colStyle,
												title: 'See all ' + order.name + ' - ' + season + ' orders for ' + STORE_NAME,
												onClick: function onClick() {
													var path = '/data/orders?brands[]=' + encodeURIComponent(order.name) + '&stores[]=' + encodeURIComponent(STORE_NAME) + '&seasons[]=' + encodeURI(season);
													window.location.href = path;
												}
											},
											order.seasons[season] && _this2.calCircle(order.seasons[season].value, min, max),
											_react2.default.createElement(
												'div',
												{ className: 'value' },
												currencyValue
											)
										);
									})
								);
							}),
							_react2.default.createElement(
								'div',
								{ className: 'oh-row oh-foot footer-start' },
								seasons.map(function (season, i) {
									return _react2.default.createElement(
										'div',
										{ className: 'oh-td', key: i },
										season
									);
								})
							),
							_react2.default.createElement(
								'div',
								{ className: 'oh-row oh-foot' },
								seasons.map(function (season, i) {
									var currencyValue = new Intl.NumberFormat('en-gb', { style: 'currency', currency: DISPLAY_CURRENCY }).format(seasonTotals[season] || 0);
									return _react2.default.createElement(
										'div',
										{ className: 'oh-td', key: i },
										currencyValue
									);
								})
							)
						)
					)
				)
			);
		}
	}, {
		key: 'calCircle',
		value: function calCircle(value, min, max) {
			var length;

			if (min === max) {
				length = 20;
			} else {

				var lmin = 5;
				var lmax = 35;
				var deltaLength = lmax - lmin;

				var deltaMinMax = max - min;
				var normValue = value - min;
				var ratio = normValue / deltaMinMax;

				length = lmin + ratio * deltaLength;
			}

			var style = {
				width: length + 'px',
				height: length + 'px'
			};

			return _react2.default.createElement('div', { className: 'circle', style: style });
		}
	}, {
		key: 'handleNextPage',
		value: function handleNextPage() {
			var pages = Math.ceil(this.data.seasons.length / 5);
			this.setState({
				page: Math.min(pages, this.state.page + 1)
			});
		}
	}, {
		key: 'handlePreviousPage',
		value: function handlePreviousPage() {
			this.setState({
				page: Math.max(1, this.state.page - 1)
			});
		}
	}, {
		key: 'sliderPosByPage',
		value: function sliderPosByPage(page) {
			var seasons = this.data.seasons.length;
			var sliderWidth = Math.max(100, seasons / 5 * 100);
			var max = sliderWidth - 100;

			return -Math.min((page - 1) * 100, max);
		}
	}]);

	return OrderHistory;
}(_react2.default.Component);

exports.default = OrderHistory;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/directory/OrderHistory.js
// module id = 515
// module chunks = 0